import { IFeatureParams, IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '../models/features.enum';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { getActiveExperienceCode, OrderBuilderState } from '@ordersnproducts/modules/order-builder/reducers';
import { ORDER_EXPERIENCES } from '@ordersnproducts/modules/shared/constants/order-experiences';
import { take } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';


@Injectable()
export class EnableOdmOrderCreation implements IFlagFeature {
  name = Features.EnableOdmOrderCreation;

  constructor(private store: Store<OrderBuilderState>) { }

  /**
   * Validates if the feature is enabled considering also the active experience for the jobsite
   * @param container
   * @param params
   * @returns
   */
  public isEnabled(container: IToggleContainer, params: IFeatureParams): boolean {
    let activeExperience;
    if (params && params.experienceCode) {
      activeExperience = params.experienceCode;
    } else {
      const subject = new BehaviorSubject<string | null>(null);
      this.store.select(getActiveExperienceCode)
        .pipe(take(1))
        .subscribe((experienceCode) => {
          activeExperience = experienceCode;
          subject.next(experienceCode);
          subject.complete();
        });
      // Espera que el BehaviorSubject emita el valor
      activeExperience = subject.getValue();
    }

    return container[this.name].isEnabled() && activeExperience === ORDER_EXPERIENCES.CEMENT_UNIVERSAL_LINK;
  }
}


